// Groups the raw report into the CSR-facing categories shown in the summary and details panels.
export const buildCategories = (report, ports = {}) => {
  const { reachability } = report;

  const categories = [
    {
      key: 'core',
      title: 'Core Connectivity',
      tests: [
        { label: 'Portal Access', port: ports.portal || '443', status: reachability.portal },
        { label: 'API Access', port: ports.api || '443', status: reachability.api },
      ],
    },
    {
      key: 'realtime',
      title: 'Real-time Services',
      tests: [
        { label: 'Notifications', port: ports.wss || '3563', status: reachability.wss },
        { label: 'Authentication', port: ports.oauth || '8443', status: reachability.oauth },
      ],
    },
  ];

  return categories.map((category) => ({
    ...category,
    status: category.tests.every((test) => test.status === 'pass') ? 'pass' : 'fail',
  }));
};
